import axiosInstance from '../utils/AxiosConfig';

class StaffTaskService {
  static async getOccurrences({ from, to, status, assigneeEmail, locationId }) {
    const response = await axiosInstance.get('/staff-tasks', {
      params: {
        from,
        to,
        status: status || undefined,
        assigneeEmail: assigneeEmail || undefined,
        locationId: locationId || undefined,
      },
    });
    const data = response.data.data;

    if (Array.isArray(data)) {
      return {
        occurrences: data,
        canManage: false,
      };
    }

    return {
      occurrences: data?.occurrences || [],
      canManage: data?.canManage === true,
    };
  }

  static async createTask(payload) {
    const response = await axiosInstance.post('/staff-tasks', payload);
    return response.data.data;
  }

  static async updateTask(taskId, payload) {
    const response = await axiosInstance.put(`/staff-tasks/${taskId}`, payload);
    return response.data.data;
  }

  static async deleteTask(taskId) {
    const response = await axiosInstance.delete(`/staff-tasks/${taskId}`);
    return response.data.data;
  }

  static async deleteOccurrence(occurrenceId) {
    const response = await axiosInstance.delete(`/staff-tasks/occurrences/${occurrenceId}`);
    return response.data.data;
  }

  static async completeOccurrence(occurrenceId) {
    const response = await axiosInstance.post(`/staff-tasks/occurrences/${occurrenceId}/complete`);
    return response.data.data;
  }

  static async reopenOccurrence(occurrenceId) {
    const response = await axiosInstance.post(`/staff-tasks/occurrences/${occurrenceId}/reopen`);
    return response.data.data;
  }
}

export default StaffTaskService;
